import { getMapboxAccessToken } from "./general";
// Map style constants
export const MAP_STYLES = {
  STANDARD: "default",
  MONOCHROME: "monochrome"
};

// Map style URLs
export const MAP_STYLE_URLS = {
  [MAP_STYLES.STANDARD]: window._env_ && window._env_.MAPBOX_STYLE_STANDARD,
  [MAP_STYLES.MONOCHROME]: window._env_ && window._env_.MAPBOX_STYLE_MONOCHROME
};


export const MAPBOX_ACCESS_TOKEN = getMapboxAccessToken();

/**
 * Get the mapbox style URL for the specified style
 * @param {string} styleId - The style ID (from MAP_STYLES)
 * @returns {string} The mapbox style URL
 */
export const getMapStyleUrl = styleId => {
  return MAP_STYLE_URLS[styleId] || MAP_STYLE_URLS[MAP_STYLES.STANDARD];
};
